import moment from 'moment-timezone';

var formatDateToLocal = function formatDateToLocal(date) {
  if (!date) return '';
  var localizedFormattedDate = moment(date).format('MM/DD/YYYY hh:mm a');
  var localThreeLetterCode = moment.tz(moment.tz.guess()).zoneAbbr();
  return "".concat(localizedFormattedDate, " ").concat(localThreeLetterCode);
};

export { formatDateToLocal };